import { render, staticRenderFns } from "./AboutMe.vue?vue&type=template&id=6e48bef6&scoped=true&v-for=(aboutMe%2C%20index)%20in%20aboutMe&%3Akey=index&"
import script from "./AboutMe.js?vue&type=script&lang=js&"
export * from "./AboutMe.js?vue&type=script&lang=js&"
import style0 from "./AboutMe.scss?vue&type=style&index=0&id=6e48bef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e48bef6",
  null
  
)

export default component.exports